'use strict';

/*global isEmpty*/
/*global services*/
/*global blockElement*/
/*global unBlockElement*/

(function ($) {
  function Lookup($lookup, options) {
    this.options = options;
    this.$lookup = $lookup;
    this.$lookupSearchResults = null;
    this.searchTimeout = null;
    this.searchDelay = 500; //v ms
    this.searchBlurTimeout = null;
    this.searchBlurDelay = 500; //v ms

    this.init();
  }

  Lookup.prototype = $.extend({}, {
    constructor: 'Lookup',

    registerCallbacks: function registerCallbacks() {
      var _this = this;

      _this.$lookup.on('click', '[data-toggle="lookup-filter"], [data-toggle="lookup"]', function () {
        _this.open($(this));
        return false;
      });

      _this.$lookup.on('keyup', 'input:text:focus', function () {
        _this.search($(this).val());
      });

      _this.$lookup.on('blur', 'input:text', function () {
        setTimeout(function () {
          _this.hideSearchResults();
        }, _this.searchBlurDelay);
      });

      _this.$lookup.on('click', '.lookup-search-result', function () {
        _this.setLookupValue($(this));
        _this.hideSearchResults();
        return false;
      });
    },

    //----------------------------------------------------------------------------

    setLookupValue: function ($btn) {
      var _this = this;

      _this.$lookup.find('input[data-lookup-field="title"]').val($btn ? $btn.data('title') : '').change();
      _this.$lookup.find('input[data-lookup-field="id"]').val($btn ? $btn.data('id') : '').change();
      _this.$lookup.data('fields_return', $btn ? $btn.data('fields_return') : '');

      if ($btn && !isEmpty($btn.data('fields_return'))) {
        var fieldsReturn = $btn.data('fields_return').split(';');
        $.each(fieldsReturn, function (key, field) {
          _this.$lookup.data('field_' + field, $btn.data('field_' + field));
          _this.$lookup.attr('data-field_' + field, $btn.data('field_' + field));
        });
      }

      _this.$lookup.trigger('changeLookup');
      _this.$lookup.find('input[data-lookup-field="id"]').trigger('changeLookupValue');

      return _this;
    },

    showSearchResults: function ($results) {
      var _this = this;

      clearTimeout(_this.searchBlurTimeout);
      _this.hideOtherLookupSearchResults();
      _this.$lookupSearchResults.html($results);
      _this.$lookupSearchResults.show();

      return _this;
    },

    hideSearchResults: function () {
      var _this = this;

      _this.$lookupSearchResults.hide();

      return _this;
    },

    hideOtherLookupSearchResults: function () {
      var _this = this;

      $('.lookup-search-results').not(_this.$lookupSearchResults).hide();

      return _this;
    },

    search: function (searchString) {
      var _this = this;

      clearTimeout(_this.searchTimeout);

      _this.searchTimeout = setTimeout(function () {
        _this.doSearch(searchString);
      }, _this.searchDelay);

      return _this;
    },

    doSearch: function (searchString) {
      var _this = this;

      if (isEmpty(searchString)) {
        _this.setLookupValue();
      }

      if (_this.options.searchEmptyString || !isEmpty(searchString)) {
        var $btn = _this.$lookup.find('.btn:first');
        var url = $btn.attr('href');

        blockElement($btn);
        $.get(url, { search_string: searchString, search: 1 }, function (res) {
          unBlockElement($btn);
          if (res.msg === 'SUCCESS') {
            _this.showSearchResults(res.data.html);
          } else {
            services.get('notifications').viewErrorMessage();
          }
        });
      } else {
        _this.hideSearchResults();
      }

      return _this;
    },

    open: function ($btn) {
      var _this = this;

      var modal = services.get('modal-lookup');

      modal.empty().open({
        title: _this.$lookup.data('lookup-title'),
        width: _this.$lookup.data('lookup-width'),
        form: false
      });

      _this.load($btn.attr('href'));

      return _this;
    },

    load: function (url, data) {
      var _this = this;

      var modal = services.get('modal-lookup');

      modal.block();
      $.get(url, data, function (res) {
        modal.unBlock();
        if (res.msg === 'SUCCESS') {
          modal.content(res.data.html);

          modal.contentDOM().find('.loadOtherItems').k2_loadOtherItems();
          modal.contentDOM().find('.lookup-form').k2_filterClear();
          modal.contentDOM().find('.lookup-table').off('click', '.selectItem a');
          modal.contentDOM().find('.lookup-table').on('click', '.selectItem a', function () {
            _this.setLookupValue($(this));
            modal.close();
            return false;
          });

          modal.contentDOM().find('.lookup-form').off('submit');
          modal.contentDOM().find('.lookup-form').on('submit', function () {
            _this.load($(this).attr('action'), $(this).serialize());
            return false;
          });

          modal.contentDOM().find('.lookup-table .order-by').off('click');
          modal.contentDOM().find('.lookup-table .order-by').on('click', function () {
            _this.load($(this).attr('href'));
            return false;
          });
        } else {
          services.get('notifications').viewErrorMessage();
        }
      });

      return _this;
    },

    //----------------------------------------------------------------------------

    init: function () {
      var _this = this;

      if (_this.$lookup.hasClass('lookup-search')) {
        _this.$lookupSearchResults = $('<div>', { class: 'lookup-search-results' });
        _this.$lookup.append(_this.$lookupSearchResults);
      }

      _this.registerCallbacks();

      return _this;
    }
  });

  var methods = {
    init: function (options) {
      var opts = $.extend({}, $.fn.k2_lookup.defaults, options);

      return this.each(function () {
        var $this = $(this);

        if ($this.hasClass('lookup-init')) {
          return;
        }

        $this.addClass('lookup-init');
        $this.data('lookup', new Lookup($this, opts));
      });
    },
  };

  $.fn.k2_lookup = function (methodOrOptions) {
    if (methods[methodOrOptions]) {
      return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
      return methods.init.apply(this, arguments);
    } else {
      $.error('Method ' + methodOrOptions + ' does not exists on jQuery.k2_lookup');
    }

  };

  $.fn.k2_lookup.defaults = {
    searchEmptyString: false
  };

})(jQuery);
